import * as React from 'react';

const SvgNavMenu = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M20 6H4v2h16V6ZM20 11H4v2h16v-2ZM20 16H4v2h16v-2Z" })
);

export { SvgNavMenu as default };
//# sourceMappingURL=NavMenu.es.js.map
